import React, { useEffect, useRef, useState } from "react";
import Isotope from "isotope-layout";
import ProjectDetailsModal from "./ProjectDetailsModal";
import img1 from "./../assets/images/services/PsEnv/1.jpg";
const Portfolio = () => {
  // init one ref to store the future isotope object
  const isotope = useRef();
  // store the filter keyword in a state
  const [filterKey, setFilterKey] = useState("*");
  const [imagesLoaded, setimagesLoaded] = useState(0);
  const [selectedProjectDetails, setSelectedProjectDetails] = useState();
  const [isOpen, setIsOpen] = useState(false);

  const htmlElement = document.getElementsByTagName("html")[0];
  const isRtl = htmlElement.getAttribute("dir") === "rtl";

  const filters = {
    Ps: "Ps Environmental Services",
    TeamRubicon: "Team Rubicon",
    Warner: "Warner Bros",
    WarnerHome: "Warner Home",
    Idealab: "Idealab",
    MarineCorps: "US Marine Corps",
    // YOUTUBE: "Youtube Videos",
    // VIMEO: "Vimeo Videos",
  };

  const types = {
    IMAGE: "image",
    VIDEO: "video",
    DOCUMENT: "document",
  };

  const projectsData = [
    {
      title: "Industrial & Environmental Services",
      type: types.DOCUMENT,
      document: {
        projectInfo:
          "Acquiring and scaling businesses in air filtration, dust collection, and industrial services — with a focus on safety, compliance, and long-term value creation.",
        client: "PS Environmental Services",
        // technologies: "iOS, HTML5, CSS3, PHP, Java",
        industry: "Baghouse / Air Pollution Control",
        date: "July, 2025",
        url: {
          name: "ps-env.com",
          link: "https://ps-env.com/",
        },

        sliderImages: [
          "images/projects/services/PsEnv/2.png",
          "images/projects/services/PsEnv/3.jpg",
          "images/projects/services/PsEnv/4.jpg",
        ],
      },

      thumbImage: "images/projects/services/PsEnv/1.jpg",

      categories: [filters.Ps],
    },
    {
      title: "Team Rubicon — Chief Financial Officer",
      type: types.DOCUMENT,
      document: {
        projectInfo:
          "Serving as CFO of Team Rubicon, a veteran-led disaster response nonprofit — driving financial strategy, operational efficiency, and sustainable growth across domestic and international programs.",
        client: "Team Rubicon",
        // technologies: "iOS, HTML5, CSS3, PHP, Java",
        industry: "Veteran-led humanitarian organization ",
        date: "Nov, 2018",
        url: {
          name: "teamrubiconusa.org",
          link: "https://teamrubiconusa.org/",
        },

        sliderImages: [
          "images/projects/services/Rubicon/LosAngels.jpg",
          "images/projects/services/Rubicon/CFOSpotlightJournal.jpg",
          "images/projects/services/Rubicon/CFOYearFinalist.jpg",
          "images/projects/services/Rubicon/Forbes.jpg",
        ],
      },

      thumbImage: "images/projects/services/Rubicon/teamrubicon_logo.jpg",

      categories: [filters.TeamRubicon],
    },
    {
      title: "The Story of Team Rubicon",
      type: types.VIDEO,
      video: {
        vimeo: false,
        id: "x9dDze9MHZs",
      },
      thumbImage: "images/projects/services/Rubicon/BuildToServe.jpg",

      categories: [filters.TeamRubicon],
    },
    {
      title:
        "Haiti Earthquake 2010 & 2021 | The Mission Lives On | Team Rubicon",
      type: types.VIDEO,
      video: {
        vimeo: false,
        id: "DpM5578XNls",
      },
      thumbImage: "images/projects/services/Rubicon/Haiti.jpg",

      categories: [filters.TeamRubicon],
    },
    {
      title: "Team Rubicon 10-yr Documentary (teaser)",
      type: types.VIDEO,
      video: {
        vimeo: false,
        id: "uasLagBDnqA",
      },
      thumbImage: "images/projects/services/Rubicon/Rubicom_10-yr.jpg",

      categories: [filters.TeamRubicon],
    },
    // {
    //   title: "Vimeo Video",
    //   type: types.VIDEO,
    //   video: {
    //     vimeo: true,
    //     id: "259411563",
    //   },

    //   thumbImage: "images/projects/project-4.jpg",
    //   categories: [filters.VIMEO],
    // },
    {
      title: "CreatorUp — SVP Finance & Corporate Administration",
      type: types.DOCUMENT,
      document: {
        projectInfo:
          "Led finance, accounting, and corporate administration for CreatorUp — a next-generation digital content studio powering global brands like Google and YouTube — driving Series B fundraising and international expansion.",
        client: "CreatorUp",
        technologies: "",
        industry: "Digital Media · SaaS",
        date: "May 2022 – Jun 2022",
        url: {
          name: "www.creatorup.com",
          link: "https://creatorup.com/",
        },
        // sliderImages: [
        //   "images/projects/project-1.jpg",
        //   "images/projects/project-2.jpg",
        // ],
      },
      thumbImage: "images/projects/services/CreatorUp/CreatorUp_logo.jpg",
      categories: [filters.DETAILED],
    },
    // {
    //   title: "Mockups Design 2",
    //   type: types.IMAGE,

    //   thumbImage: "images/projects/project-6.jpg",

    //   categories: [filters.MOCKUPS],
    // },

    {
      title: "Warner Bros. — Finance Director, Canada & Mexico",
      type: types.DOCUMENT,
      document: {
        projectInfo: `Led all financial operations for Warner Bros.' Canadian and Mexican markets, overseeing P&L, budgeting, forecasting, and strategic planning across video, digital distribution, and video games divisions.
        As Finance Director, I managed the complete income statement, balance sheet, 
        and cash flow for two major international markets. I partnered closely with 
        the Managing Director to develop financial, operational, and strategic models 
        that drove better business decisions and optimized market performance.

        I led the annual operating budget process and monthly reforecasts in 
        collaboration with commercial sales and marketing teams, while developing 
        dashboards and operational metrics that gave executive leadership real-time 
        visibility into business performance. My work with supply chain teams 
        streamlined product shipment and inventory management across retail and 
        distribution channels, directly improving margins and days of supply.`,
        client: "Warner Bros",
        technologies: "",
        industry: "Entertainment · Media · Consumer Goods",
        date: "Jan 2012 – Nov 2018",
        url: {
          name: "www.warnerbros.com",
          link: "https://www.warnerbros.com/",
        },
        // sliderImages: [
        //   "images/projects/project-1.jpg",
        //   "images/projects/project-2.jpg",
        // ],
      },
      thumbImage:
        "images/projects/services/warnerbros/warner_bros__entertainment_logo.jpg",
      categories: [filters.Warner],
    },

    {
      title: "Warner Bros. — Director of FP&A",
      type: types.DOCUMENT,
      document: {
        projectInfo: `Led the global forecast process for Warner Bros., ensuring accurate and 
          timely financial reporting across all business units. I partnered with 
          Corporate Planning, Business Unit Finance, Regional Finance, and Accounting 
          teams to validate key forecasting assumptions and drive operating margin 
          improvements.

          I chaired quarterly finance reviews with Division leadership — including the 
          President and CFO — with a sharp focus on overall profitability and key 
          business drivers. I established the corporate financial calendar covering 
          AOP, forecasting, and close cycles, and created analytical tools and KPI 
          dashboards that gave management the insights needed to make faster, smarter 
          decisions.`,
        client: "Warner Bros",
        technologies: "",
        industry: "Entertainment · Media · Consumer Goods",
        date: "Apr 2006 – Jan 2012",
        url: {
          name: "www.warnerbros.com",
          link: "https://www.warnerbros.com/",
        },
        // sliderImages: [
        //   "images/projects/project-1.jpg",
        //   "images/projects/project-2.jpg",
        // ],
      },
      thumbImage:
        "images/projects/services/warnerbros/warner_bros__entertainment_logo.jpg",
      categories: [filters.Warner],
    },
    {
      title: "Warner Bros. — Manager of FP&A",
      type: types.DOCUMENT,
      document: {
        projectInfo: `Supported the financial planning and analysis function at Warner Bros., 
          contributing to budgeting, forecasting, and reporting processes across 
          the organization. Built foundational expertise in large-scale financial 
          operations, working within one of the world's most iconic entertainment 
          companies during a period of significant industry transformation driven 
          by the rise of digital media.`,
        client: "Warner Bros",
        technologies: "",
        industry: "Entertainment · Media · Consumer Goods",
        date: "Apr 2003 – Apr 2006",
        url: {
          name: "www.warnerbros.com",
          link: "https://www.warnerbros.com/",
        },
        // sliderImages: [
        //   "images/projects/project-1.jpg",
        //   "images/projects/project-2.jpg",
        // ],
      },
      thumbImage:
        "images/projects/services/warnerbros/warner_bros__entertainment_logo.jpg",
      categories: [filters.Warner],
    },
    {
      title: "Warner Home Video — Sr. Financial Analyst",
      type: types.DOCUMENT,
      document: {
        projectInfo: `Managed international financial reporting and consolidation for Warner 
          Home Video, ensuring accurate and timely financial statements across 
          global markets. Developed deep expertise in international finance 
          operations, multi-currency consolidation, and cross-border reporting 
          standards — building the analytical foundation that would support a 
          25-year career in financial leadership.`,
        client: "Warner Home Video",
        technologies: "",
        industry: "Entertainment · Media · Consumer Goods",
        date: "Dec 2000 – Apr 2003",
        url: {
          name: "www.warnerbros.com",
          link: "https://www.warnerbros.com/",
        },
        // sliderImages: [
        //   "images/projects/project-1.jpg",
        //   "images/projects/project-2.jpg",
        // ],
      },
      thumbImage: "images/projects/services/warnerbros/WarnerHome.jpg",
      categories: [filters.WarnerHome],
    },
    {
      title: "Idealab — Accountant",
      type: types.DOCUMENT,
      document: {
        projectInfo: `Worked as an accountant at Idealab — one of the most prolific technology 
        startup studios in the world, founded by Bill Gross in Pasadena, CA. 
        Gained early exposure to the fast-paced world of venture-backed startups, 
        supporting financial operations during a pivotal era of internet innovation 
        and growth.`,
        client: "Idealab",
        technologies: "",
        industry: "Technology · Startup · Venture",
        date: "Aug 1999 – Dec 2000",
        url: {
          name: "www.idealab.com",
          link: "https://www.idealab.com/",
        },
        // sliderImages: [
        //   "images/projects/project-1.jpg",
        //   "images/projects/project-2.jpg",
        // ],
      },
      thumbImage: "images/projects/services/IdeaLab/idealab_logo.jpg",
      categories: [filters.Idealab],
    },
    // {
    //   title: "Com Global Systems — Accountant",
    //   type: types.DOCUMENT,
    //   document: {
    //     projectInfo: `Began professional accounting career at Com Global Systems, supporting
    //     financial operations for an IT services company in the Greater San Diego
    //     area. Built core accounting fundamentals that laid the groundwork for
    //     a distinguished career in financial leadership across multiple industries.`,
    //     client: "Com Global Systems",
    //     technologies: "",
    //     industry: "Technology · IT Services",
    //     date: "Jun 1998 – Aug 1999",
    //     url: {
    //       name: "www.comglobalsystems.com",
    //       link: "https://www.comglobalsystems.com/",
    //     },
    //   },
    //   thumbImage: "images/projects/services/IdeaLab/idealab_logo.jpg",
    //   categories: [filters.Idealab],
    // },

    {
      title: "US Marine Corps — Military Service",
      type: types.DOCUMENT,
      document: {
        projectInfo: `Served honorably in the United States Marine Corps for over five years — 
          an experience that instilled the core values of discipline, leadership, 
          integrity, and mission-focus that have defined every chapter of a 
          25-year career in business and finance. The Marines didn't just build 
          character — they set the standard for it.`,
        client: "US Marine Corps",
        technologies: "",
        industry: "Military · Public Service · Leadership",
        date: "Jul 1988 – Jul 1993 ",
        url: {
          name: "www.marines.mil",
          link: "https://www.marines.mil/",
        },
        // sliderImages: [
        //   "images/projects/project-1.jpg",
        //   "images/projects/project-2.jpg",
        // ],
      },
      thumbImage: "images/projects/services/UsMarine/marines_logo.jpg",
      categories: [filters.MarineCorps],
    },
  ];

  // initialize an Isotope object with configs
  useEffect(() => {
    isotope.current = new Isotope(".portfolio-filter", {
      itemSelector: ".filter-item",
      layoutMode: "masonry",
      originLeft: !isRtl,
    });

    // cleanup
    return () => {
      isotope.current.destroy();
    };
  }, []);

  // handling filter key change
  useEffect(() => {
    if (imagesLoaded) {
      filterKey === "*"
        ? isotope.current.arrange({ filter: `*` })
        : isotope.current.arrange({ filter: `.${filterKey}` });
    }
  }, [filterKey, imagesLoaded]);

  const handleFilterKeyChange = (key) => () => setFilterKey(key);

  const getKeyByValue = (value) => {
    return Object.keys(filters).find((key) => filters[key] === value);
  };

  const getFilterClasses = (categories) => {
    if (categories.length > 0) {
      let tempArray = [];
      categories.forEach((category, index) => {
        tempArray.push(getKeyByValue(category));
      });
      return tempArray.join(" ");
    }
  };

  return (
    <>
      <section id="portfolio" className={"section bg-light"}>
        <div className={"container"}>
          {/* Heading */}
          <p className="text-center mb-2 wow fadeInUp">
            <span className="bg-primary text-dark px-2">Portfolio</span>
          </p>
          <h2 className="text-10 fw-600 text-center mb-5 wow fadeInUp">
            Some of my professional work details
          </h2>
          {/* Heading end*/}
          {/* Filter Menu */}
          <ul
            className={
              "portfolio-menu nav nav-tabs fw-600 justify-content-start justify-content-md-center border-bottom-0 mb-5 wow fadeInUp"
            }
          >
            <li className="nav-item">
              <button
                className={"nav-link " + (filterKey === "*" ? "active" : "")}
                onClick={handleFilterKeyChange("*")}
              >
                All
              </button>
            </li>
            {Object.keys(filters).map((oneKey, i) => (
              <li className="nav-item" key={i}>
                <button
                  className={
                    "nav-link " + (filterKey === oneKey ? "active" : "")
                  }
                  onClick={handleFilterKeyChange(oneKey)}
                >
                  {filters[oneKey]}
                </button>
              </li>
            ))}
          </ul>
          {/* Filter Menu end */}
          <div className="portfolio wow fadeInUp">
            <div className="row portfolio-filter filter-container g-4">
              {projectsData.length > 0 &&
                projectsData.map((project, index) => (
                  <div
                    className={
                      "col-sm-6 col-lg-4 filter-item " +
                      getFilterClasses(project.categories)
                    }
                    key={index}
                  >
                    <div className="portfolio-box">
                      <div className="portfolio-img">
                        <img
                          onLoad={() => {
                            setimagesLoaded(imagesLoaded + 1);
                          }}
                          className="img-fluid d-block portfolio-image"
                          src={project.thumbImage}
                          alt=""
                        />
                        <div
                          className="portfolio-overlay"
                          onClick={() => {
                            setSelectedProjectDetails(projectsData[index]);
                            setIsOpen(true);
                          }}
                        >
                          <button className="popup-ajax stretched-link border-0 p-0 ">
                            {" "}
                          </button>
                          <div className="portfolio-overlay-details">
                            <p className="text-primary text-8">
                              {project.type === types.DOCUMENT && (
                                <i className="fas fa-file-alt"></i>
                              )}
                              {project.type === types.IMAGE && (
                                <i className="fas fa-image"></i>
                              )}
                              {project.type === types.VIDEO && (
                                <i className="fas fa-video"></i>
                              )}
                            </p>
                            <h5 className="text-white text-5">
                              {project?.title}
                            </h5>
                            <span className="text-light">Category</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </section>
      {/* Modal */}
      {isOpen && (
        <ProjectDetailsModal
          projectDetails={selectedProjectDetails}
          setIsOpen={setIsOpen}
        ></ProjectDetailsModal>
      )}
    </>
  );
};

export default Portfolio;
